import browser from 'detect-browser'

const showAlertBrowserNotSupport = function () {
  let alert = document.createElement('div')
  alert.className = 'alert alert-danger'
  alert.innerHTML = 'Ваш браузер сильно устарел или не поддерживается. Стабильная работа не гарантируется. Пожалуйста обновите свой браузер. Рекомендуется использовать <a href="https://www.google.ru/chrome/browser/desktop/index.html" target="_blank">Google Chrome</a> последней версии.'
  let s = document.body.firstChild
  s.parentNode.insertBefore(alert, s)
}

const showAlertIENotSupport = function () {
  let alert = document.createElement('div')
  alert.className = 'alert alert-danger'
  alert.innerHTML = 'Вы используете бразуер Internet Explorer. Стабильная работа в нем не гаранитируется. Рекомендуется использовать <a href="https://www.google.ru/chrome/browser/desktop/index.html" target="_blank">Google Chrome</a> последней версии.'
  let s = document.body.firstChild
  s.parentNode.insertBefore(alert, s)
}

const checkBrowser = function () {
  if (browser) {
    switch (browser.name) {
      case 'chrome':
        if (parseFloat(browser.version) < 52) {
          showAlertBrowserNotSupport()
        }
        break
      case 'ie':
        showAlertIENotSupport()
        break
      case 'firefox':
        if (parseFloat(browser.version) < 44) {
          showAlertBrowserNotSupport()
        }
        break
      case 'opera':
        if (parseFloat(browser.version) < 36) {
          showAlertBrowserNotSupport()
        }
        break
      case 'safari':
        if (parseFloat(browser.version) < 5) {
          showAlertBrowserNotSupport()
        }
        break
    }
  }
}

document.body.onload = checkBrowser



// WEBPACK FOOTER //
// ./src/detect-browser-main.js